export default __webpack_public_path__ + "static/media/KOD0001-min.71dd2158.webp";